module.exports = __webpack_public_path__ + "static/media/logo_text@2x.d977a9a8.png";